import React from "react";
import LinkedTravelRowCard from "./linkedtravelrow";

interface IProps {
  appointments: server.dto.PlannerAppointment[]
  icon: string
  title: string
  unlink: (appointmentId: number) => void
  canLinkUnlinkTravel: boolean
}

// TODO: See if these get updated and how
const LinkedTravelRows = (props: IProps) => {
  if (!props.appointments || props.appointments.length === 0) {
    return null;
  }

  return (<div className="margin-bottom">

    <div className="list-with-gaps card-layout">
      <div className="list-with-gaps-header">
        <div className="flex gap align-center" style={{ background: "none", paddingTop: 0, paddingLeft: 4 }}>
          <div>
            <i className={props.icon}></i>
          </div>
          <div className="">
            <h3>{props.title}</h3>
          </div>
        </div>
      </div>

      <div className="list-with-gaps-body">
        {props.appointments
          .sort((a, b) => new Date(a.dateStart).valueOf() - new Date(b.dateStart).valueOf())
          .map((app) => (
            <LinkedTravelRowCard
              key={app.trainId || app.flightId || app.groundTransportId}
              appointment={app}
              unlink={props.unlink}
              canLinkUnlinkTravel={props.canLinkUnlinkTravel}
            />
          ))}
      </div>
    </div>
  </div>
  );
};

export default LinkedTravelRows;